// Page geometry, in one place.
//
// The sheet is drawn 1018px wide and that is US Letter's 8.5in, which fixes
// the editor's scale at ~120px per inch (a comfortable ~1.25x of CSS's 96dpi).
// Everything else follows from that, so a page break lands where the paper
// would actually end instead of at a number someone picked.
//
// The old code used 1375px sheets with 1255px of content, which is 11.5in of
// paper — the breaks could never have matched a printed page.

export const PAGE_WIDTH_PX = 1018;
export const PX_PER_INCH = PAGE_WIDTH_PX / 8.5; // ~119.8

export const PAGE_HEIGHT_PX = Math.round(11 * PX_PER_INCH); // ~1317

/** Top and bottom margin — 1in, matching the Docs/Word default. */
export const PAGE_MARGIN_PX = Math.round(PX_PER_INCH);

/** Usable height of one page: what the paginator fills before breaking. */
export const PAGE_CONTENT_HEIGHT_PX = PAGE_HEIGHT_PX - 2 * PAGE_MARGIN_PX;

/**
 * Space a page break occupies inline: enough to read as a boundary, not the
 * whole remainder of the sheet. The editor is one continuous surface, so the
 * break is a marker rather than a physical gap between sheets.
 */
export const PAGE_BREAK_HEIGHT_PX = 44;

/**
 * The desk showing between two sheets — about half a centimetre of it. Only
 * this strip is background; the page margins either side of it are paper.
 */
export const PAGE_SHEET_GAP_PX = Math.round((0.5 / 2.54) * PX_PER_INCH);

/**
 * Total space a print-layout break occupies: the bottom margin of the page
 * that is ending, the gap, and the top margin of the one starting. Both
 * margins match the space above the document's first line.
 */
export const PAGE_SHEET_CHROME_PX = 2 * PAGE_MARGIN_PX + PAGE_SHEET_GAP_PX;

/**
 * How far the gap between sheets reaches past the paper's edge. The sheet
 * draws a 1px border and a soft shadow down its whole height, and both would
 * otherwise show as hairlines running across the gap.
 */
export const PAGE_EDGE_OVERHANG_PX = 10;
